const environment = {
  appVersion: "3.11.42",
  googleMapsLibraries: ["places"],
  cacheVersion: "3",
};

export default environment;
